module.exports = __webpack_public_path__ + "static/media/text-icon-not-active.2d4701ca.svg";